<script setup lang="ts">
/**
 * The footer (design prototype `<footer>`, start version): the wordmark without addition, who
 * built it (B-23; the partners' logos follow when marketing has them), "Cookie-Einstellungen",
 * which withdraws the stored choice and shows the consent banner again (ADR-141 point 5, like the
 * website's footer), and the colour-scheme choice, so guests can switch it too.
 */
import { reopenConsent } from "@ai-platform/ui/consent.ts";
import BrandWordmark from "./BrandWordmark.vue";
import ThemePicker from "./ThemePicker.vue";
</script>

<template>
  <footer class="border-line px-safety flex flex-wrap items-center justify-between gap-4 border-t py-6 md:px-8">
    <div class="flex flex-wrap items-center gap-x-4 gap-y-2">
      <BrandWordmark class="text-text-head h-6" />
      <p class="text-meta text-text-soft m-0" data-partners>Umgesetzt mit pixelpoint × dataCycle</p>
      <button
        type="button"
        class="rounded-chip text-meta text-text-soft hover:text-text-head focus-visible:outline-focus cursor-pointer border-0 bg-transparent p-0 hover:underline focus-visible:outline-2 focus-visible:outline-offset-2"
        data-consent-settings
        @click="reopenConsent()"
      >
        Cookie-Einstellungen
      </button>
    </div>
    <ThemePicker />
  </footer>
</template>
